module.exports = __webpack_public_path__ + "static/media/whiteV.a2a3f693.svg";